// Small helpers for Spanish grammatical-gender agreement on category-driven
// copy — "{Categoría} única(s)" needs the adjective to match the noun's
// gender ("Chaquetas únicas" / "Abrigos únicos"), and there's no single
// default that's correct for every category.
import i18n from '../i18n';

// Keyed by slug (stable) rather than display name; anything not listed
// falls back to the masculine plural, the more common case among current
// categories (Abrigos, Vestidos, Blazers, Jeans, Tops, ...).
const FEMININE_CATEGORY_SLUGS = new Set(['chaquetas', 'capas', 'faldas', 'camisas']);

/**
 * Returns "únicas" or "únicos" to agree with the given category slug.
 * For English ("en*") returns "unique" — English adjectives don't inflect.
 * `lang` defaults to the active i18n language.
 */
export const uniqueWordForCategory = (slug, lang = i18n.language) => {
  if ((lang || 'es').toLowerCase().startsWith('en')) return 'unique';
  return FEMININE_CATEGORY_SLUGS.has((slug || '').toLowerCase()) ? 'únicas' : 'únicos';
};
